enum BaseURLConfig {
  PALMETTO,
  DECON,
}

export default BaseURLConfig;
